module.exports = __webpack_public_path__ + "static/tranquility-fr-logo-8a486265e3f542ec8eb61e464ccdd82c.png";